import './_article-2-column-image-copy.scss';

export default () => {};
